import { FunctionComponent } from 'react';
import clsx from 'clsx';
import { PriceField } from '../../../../UI/V3/Forms/PriceField/PriceField';
import styles from './PriceHours.module.scss';
import lockStyles from '../../../UI/priceFieldInteractionLock.module.scss';
import { usePermissions } from 'hooks';
import { isHourlyDaycareVariableDuration } from 'components/CreateBooking/utils/membershipDisplayPrice';

interface Duration {
    hours: number;
    minutes: number;
}

interface PriceHoursProps {
    price: number;
    duration?: Duration;
    variableDuration?: string;
    label: string;
    onChangePrice: (price: number) => void;
}

export const PriceHours: FunctionComponent<PriceHoursProps> = props => {
    const { price, duration, variableDuration, label, onChangePrice } = props;
    const permissions = usePermissions();
    const canEditPrices = permissions.checkout.editPrices;

    const getRange = () => {
        if (isHourlyDaycareVariableDuration(variableDuration)) {
            return 'Hourly';
        }

        if (duration) {
            const totalHours = duration.hours + duration.minutes / 60;

            if (totalHours <= 2) {
                return 'Up to 2 hours';
            } else if (totalHours <= 4) {
                return 'Up to 4 hours';
            } else if (totalHours <= 6) {
                return 'Up to 6 hours';
            } else if (totalHours <= 8) {
                return 'Up to 8 hours';
            } else if (totalHours <= 10) {
                return 'Up to 10 hours';
            } else if (totalHours <= 12) {
                return 'Up to 12 hours';
            } else {
                return 'More than 12 hours';
            }
        }

        return 'Hour';
    };

    return (
        <div className={styles.priceHoursContainer}>
            <div className={styles.priceFieldWrapper}>
                <label className={styles.label}>{label}</label>
                <div
                    className={clsx(styles.priceFieldContainer, {
                        [lockStyles.interactionLock]: !canEditPrices
                    })}
                >
                    <PriceField
                        scale={2}
                        value={price || 0.0}
                        onChange={value => onChangePrice(value || 0.0)}
                        className={styles.priceField}
                        placeholder="0.00"
                    />
                    <div className={styles.durationText}>{getRange()}</div>
                </div>
            </div>
        </div>
    );
};

export default PriceHours;
